class PreloaderPage{
  constructor(){
      this.node = document.querySelector('.preloader-page');
      this.coolLoader = this.node.querySelector('.cool-loader');
      if (!this.node) return;
  }
  hide(){
    if (!this.node) return;
    this.node.classList.add('mod--hidden')
    // this.node.classList.remove('mod--playing')
    this.coolLoader.classList.remove('cool-loader--playing')
  }

  showOnUnload(){
    if (!this.node) return;
    // this.node.classList.add('mod--playing')
    // пусть лучше будет и дергается, пушо на 3G при включенном кеше браузера при повторном посещении страниц
    // по факту покажется только это, и если оно не будет анимированым - то будет так-себе
    this.coolLoader.classList.add('cool-loader--playing')
    this.node.classList.remove('mod--hidden')
  }
}

export default PreloaderPage;



// WEBPACK FOOTER //
// ./src/includes/PreloaderPage.js